import React, { Children, isValidElement, ReactNode } from 'react'
import classnames from 'classnames'
import { RadioGroupContext } from './GroupContext'
import { usePropsValue } from '@hooks/UsePropsValue'
import Radio from './Radio'
import WebUI from '@utils/UpdatePrefixs';
import RadioControl from './RadioControl';

import { RadioGroupProps, RadioValue } from './iRadio'

const defaultProps = {
  disabled: false,
  defaultValue: null,
  browser: false,
  browserShow: false,
}

function Group(props: RadioGroupProps) {
  const {
    clsPrefix,
    children,
    browser,
    browserShow,
    browserClassName,
    browserStyle,
  } = props
  const [value, setValue] = usePropsValue({
    value: props.value,
    defaultValue: props.defaultValue,
    onChange: v => {
      if (v === null) return
      props.onChange?.(v)
    },
  })

  // 浏览态下找出选中的Radio并获取其文本内容
  const findSelectedRadioText = (): ReactNode => {
    if (!children) return '--';

    // 获取所有Radio子组件及其children
    const childrenArray = Children.toArray(children);
    let selectedText: ReactNode = null;

    // 遍历所有子元素寻找选中的Radio
    const findInChildren = (children: React.ReactNode[]): boolean => {
      for (const child of children) {
        // 如果是有效的React元素
        if (isValidElement(child)) {
          // 如果是Radio元素且值匹配
          if (child.type === Radio && child.props.value === value) {
            selectedText = child.props.children;
            return true;
          }
          // 检查div或其他容器内的Radio
          else if (child.props.children) {
            const childrenArr = Children.toArray(child.props.children);
            if (findInChildren(childrenArr)) {
              return true;
            }
          }
        }
      }
      return false;
    };

    findInChildren(childrenArray);
    return selectedText;
  };

  const findDataSource = () => {
    if (!children) return null;
    const childrenArray = Children.toArray(children);
    const selectedSource: any = [];
    const selectedValue: string[] = [];

    // 遍历所有子元素寻找选中的Radio
    const findInChildren = (children: React.ReactNode[]): boolean => {
      for (const child of children) {
        // 如果是有效的React元素
        if (isValidElement(child)) {
          // 如果是Radio元素且值匹配
          if (child.type === Radio) {
            const temp = { value: child.props.value, text: child.props.children };
            selectedSource.push(temp);
            child.props.value === value && selectedValue.push(child.props.value);
          }
          // 检查div或其他容器内的Radio
          else if (child.props.children) {
            const childrenArr = Children.toArray(child.props.children);
            if (findInChildren(childrenArr)) {
              return true;
            }
          }
        }
      }
      return false;
    };

    findInChildren(childrenArray);
    return { dataSource: selectedSource, value: selectedValue };
  }

  // 如果是浏览态且不需要平铺显示，只显示选中项的文本
  if (browser) {
    if (browserShow) {
      const temp = findDataSource();
      return temp?.dataSource ? <RadioControl dataSource={temp?.dataSource} value={temp?.value} browser browserShow browserClassName={browserClassName} browserStyle={browserStyle}/> : null
       
    }
    const selectedText = findSelectedRadioText();
    if (selectedText) {
      return (
        <div className={classnames(`${clsPrefix}-component-browser`)}>
          <div className={classnames(`${clsPrefix}-radio-group-browser`, { [`${browserClassName}`]: browserClassName })} style={browserStyle} fieldid={props.fieldid ? props.fieldid : undefined}>
            {selectedText}
          </div>
        </div>
      );
    }
    return '--'; // 如果没有选中项，不显示内容
  }

  return (
    <RadioGroupContext.Provider
      value={{
        value: value === null ? [] : [value],
        check: v => {
          setValue(v)
        },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        uncheck: () => {},
        disabled: props.disabled || false,
      }}
    >
      {props.children}
    </RadioGroupContext.Provider>
  )
}

export default WebUI({ defaultProps })(Group)
